export default class CollapseLongContent extends HTMLElement {
    constructor() {
        super();
        this.isExpanded = false;
    }

    connectedCallback() {
        this.linesMax = parseInt(this.getAttribute('lines-max')) || 4;
        this.render();
        this.checkContentHeight();
        window.addEventListener('resize', () => this.checkContentHeight());
    }

    render() {
        const content = this.innerHTML;
        this.innerHTML = `
            <div class="wrapper">
                <div class="content">${content}</div>
                <a href="#" class="toggle" style="display: none;">Lire la suite</a>
            </div>
        `;
        this.classList.add('collapsed');
        this.style.setProperty('--lines-max', this.linesMax);
    }

    checkContentHeight() {
        if (this.isExpanded) return;

        const content = this.querySelector('.content');
        const toggle = this.querySelector('.toggle');
        const lineHeight = parseInt(window.getComputedStyle(content).lineHeight);
        const maxHeight = lineHeight * this.linesMax;

        if (content.scrollHeight > maxHeight) {
            toggle.style.display = 'inline-block';
            this.classList.add('collapsed');
            this.setupEventListeners();
        } else {
            toggle.style.display = 'none';
            this.classList.remove('collapsed');
        }
    }

    setupEventListeners() {
        const toggle = this.querySelector('.toggle');
        if (!toggle.hasListener) {
            toggle.addEventListener('click', (e) => this.expand(e));
            toggle.hasListener = true;
        }
    }

    expand(e) {
        e.preventDefault();
        this.isExpanded = true;
        this.classList.remove('collapsed');
        this.querySelector('.toggle').style.display = 'none';
    }
}